export const fullAddressMixin = {
  data() {
    return {
      stateOptions:[],
      residentLgaOptions:[],
    };
  },
  methods: {
    stateChange(){
        this.residentLgaOptions = [];
        if(!this.data.residential_address.state_id){
            return
        }
        this.isLoading = true
        this.$http.get(`${this.absoluteUrl()}/api/local-governments?state_id=${this.data.residential_address.state_id}`)
            .then((response) => {
            this.isLoading = false
            if(response.data.success){
                this.residentLgaOptions = response.data.data
            }
        })
    },
  },
};